function generateDummyArray(numberOfItems: number): number[] {
    return [...Array(numberOfItems).keys()];
}

export { generateDummyArray };
